import { InformationPad } from '../../../components/shared';
import { formatNumberOrReturnZero, getDateFormat } from '../../../utils/common-methods';
import dayjs from 'dayjs';

const ModemDetailAccordion = ({ modemInfo }) => {
  if (!modemInfo) {
    return null;
  }

  const processedModemInfo = {
    ...modemInfo,
    price: modemInfo?.price || 0,
  };

  const fields = [
    { label: 'Type', value: processedModemInfo?.modem?.type || 'N/A' },
    { label: 'MAC Address', value: processedModemInfo?.modem?.MACAddress || 'N/A' },
    {
      label: 'Installed Date',
      value: processedModemInfo?.modem?.installedDate
        ? dayjs(processedModemInfo?.modem?.installedDate).format('MM/DD/YYYY')
        : 'N/A',
    },
    { label: 'Price', value: `$${formatNumberOrReturnZero(processedModemInfo?.price)}` },
    { label: 'Login ID', value: processedModemInfo?.loginId || 'N/A' },
    { label: 'Password', value: processedModemInfo?.password || 'N/A' },
    { label: 'Serial Number', value: processedModemInfo?.modem?.serialNumber || 'N/A' },
    {
      label: 'In Effect From',
      value: getDateFormat(processedModemInfo?.inEffectFrom) || 'N/A',
    },
    {
      label: 'In Effect To',
      value: getDateFormat(processedModemInfo?.inEffectTo) || '',
    },
  ];

  return <InformationPad data={fields} />;
};

export default ModemDetailAccordion;
